<template>
  <div class="px-5 pt-5">
    <b-card>
      <b-card-body>
        <div class="row">
          <div class="col-12">
            <h4 class="text-primary mb-3">Comprobante</h4>
          </div>
          <div class="col-6 mt-3">
            <div>
              <strong>Fecha de emisión</strong>
              <div class="ml-3">
                {{receipt.fechaCreacion | dateFormat }}
              </div>
            </div>
          </div>
          <div class="col-6 mt-3">
            <div>
              <strong>Estado</strong>
              <div class="ml-3">
                {{receiptsStates[receipt.estado].label }}
              </div>
            </div>
          </div>
          <div class="col-6 mt-3" v-if="receipt.fechaMaximaPago">
            <div>
              <strong>Fecha máxima de pago</strong>
              <div class="ml-3">
                {{receipt.fechaMaximaPago}}
              </div>
            </div>
          </div>
          <div class="col-6 mt-3" v-if="receipt.monto">
            <div>
              <strong>Monto del comprobante</strong>
              <div class="ml-3">
                {{receipt.monto | amount}}
              </div>
            </div>
          </div>
          <div class="col-6 mt-3" v-if="receipt.iva">
            <div>
              <strong>Iva</strong>
              <div class="ml-3">
                {{receipt.iva | amount}}
              </div>
            </div>
          </div>
          <div class="col-6 mt-3" v-if="receipt.impuestoEspecifico">
            <div>
              <strong>Impuesto específico</strong>
              <div class="ml-3">
                {{receipt.impuestoEspecifico | amount}}
              </div>
            </div>
          </div>
          <div class="col-6 mt-3" v-if="receipt.garantiaMonto">
            <div>
              <strong>Monto Garantía</strong>
              <div class="ml-3">
                {{receipt.garantiaMonto | amount}}
              </div>
            </div>
          </div>
          <div class="col-6 mt-3" v-if="receipt.montoPorPagar">
            <div>
              <strong>Monto Por Pagar</strong>
              <div class="ml-3">
                {{receipt.montoPorPagar | amount}}
              </div>
            </div>
          </div>
          <div class="col-6 mt-3" v-if="receipt.montoTotal">
            <div>
              <strong>Monto Total del comprobante</strong>
              <div class="ml-3">
                {{receipt.montoTotal | amount}}
              </div>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
    <b-card>
      <b-card-body>
        <div class="row">
          <div class="col-12">
            <h4 class="text-primary mb-3">Adjudicatario</h4>
          </div>
          <div class="col-6 mt-3">
            <div>
              <strong>Rut</strong>
              <div class="ml-3">
                {{receipt.adjudicatarios.rut}}
              </div>
            </div>
          </div>
          <div class="col-6 mt-3">
            <div>
              <strong>Razón Social</strong>
              <div class="ml-3">
                {{receipt.adjudicatarios.nombre}}
              </div>
            </div>
          </div>
          <div class="col-6 mt-3">
            <div>
              <strong>Ciudad</strong>
              <div class="ml-3">
                {{receipt.adjudicatarios.ciudad}}
              </div>
            </div>
          </div>
          <div class="col-6 mt-3">
            <div>
              <strong>Teléfono</strong>
              <div class="ml-3">
                {{receipt.adjudicatarios.telefono}}
              </div>
            </div>
          </div>
          <div class="col-6 mt-3">
            <div>
              <strong>Correo</strong>
              <div class="ml-3">
                {{receipt.adjudicatarios.correo}}
              </div>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
    <b-card>
      <b-card-body>
        <div class="row">
          <div class="col-12">
            <h4 class="text-primary mb-3">Subasta</h4>
          </div>
          <div class="col-6 mt-3">
            <div>
              <strong>Folio</strong>
              <div class="ml-3">
                {{receipt.subasta.folio}}
              </div>
            </div>
          </div>
          <div class="col-6 mt-3">
            <div>
              <strong>Rut</strong>
              <div class="ml-3">
                {{receipt.subasta.gestora.iut}}
              </div>
            </div>
          </div>
          <div class="col-12 mt-3">
            <div>
              <strong>Razón Social</strong>
              <div class="ml-3">
                {{receipt.subasta.gestora.razonSocial}}
              </div>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
    <b-card>
      <b-card-body>
        <div class="row">
          <div class="col-12">
            <h4 class="text-primary mb-3">Lote</h4>
          </div>
          <div class="col-6 mt-3">
            <div>
              <strong>Folio</strong>
              <div class="ml-3">
                {{receipt.lote.folio}}
              </div>
            </div>
          </div>
          <div class="col-6 mt-3">
            <div>
              <strong>Calidad Juridica</strong>
              <div class="ml-3">
                {{receipt.lote.calidadJuridicaNombre}}
              </div>
            </div>
          </div>
          <div class="col-12 mt-3">
            <div>
              <strong>Descripción lote</strong>
              <div class="ml-3 container-description">
                {{receipt.lote.descripcionLote}}
              </div>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
import { receiptsStates } from '@/febos/aduanas/receipts/views/utils/constants';

export default {
  name: 'DetailReceipt',
  data() {
    return {
      receiptsStates
    };
  },
  props: ['receipt']
};
</script>
<style>

</style>
